/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export default function DatePickerRange({
  scheduleEndDate, setScheduleEndDate,scheduleStartDate, setScheduleStartDate,
}) {
  // const [startDate, setStartDate] = React.useState(null);
  // const [endDate, setEndDate] = React.useState(null);
 
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} sx={{ display: 'flex', alignItems: 'center' }}>
      <DatePicker
        minDate={new Date()}
        label="Start Date"
        // minDate={dayjs()}
        // sx={{ width:  }}
        value={scheduleStartDate}
        onChange={(newValue) => {
          // console.log('new VAlue ===>',newValue);
          setScheduleStartDate(newValue);
          setScheduleEndDate(newValue);
        }}
        // readOnly
        renderInput={(params) => <TextField size="small" className="!rounded-[10px]" sx={{ width: 100 }} {...params} />}
      />
    </LocalizationProvider>
  );
}
